/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import Tooltip from "../../Tooltip";
import "./withTooltip.scss";

export interface WithTooltipProps {
    tooltip?: string | React.ReactElement;
    ignoreTooltip?: boolean;
    tooltipIconColor?: string;
    withTooltipStyle?: React.CSSProperties;
    componentContainerStyle?: React.CSSProperties;
}

// So kann auch eine generische Komponente mit withTooltip verwendet werden
// https://codewithstyle.info/Typing-Higher-Order-Components-in-React/
type FunctionComponent<P> = (props: P) => JSX.Element;

export default function withTooltip<P extends {}>(
    Component: FunctionComponent<P>
): FunctionComponent<P & WithTooltipProps> {
    function WrappedComponent({ tooltip, ignoreTooltip, tooltipIconColor, ...props }: WithTooltipProps) {
        function getTooltipStyle(): string {
            let result = "lan-withtooltip__tooltipcontainer";
            if (!tooltip) {
                result += " lan-withtooltip__tooltipcontainer--hidden";
            }

            if (ignoreTooltip) {
                result += " lan-withtooltip__tooltipcontainer--none";
            }

            return result;
        }

        return (
            <div className="lan-withtooltip" style={props.withTooltipStyle}>
                <div className="lan-withtooltip__componentcontainer" style={props.componentContainerStyle}>
                    <Component {...(props as P)} />
                </div>
                <div className={getTooltipStyle()}>
                    <Tooltip title={tooltip ?? ""} iconColor={tooltipIconColor} />
                </div>
            </div>
        );
    }

    return WrappedComponent;
}
